import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-chevron-left',
	templateUrl: './icon-chevron-left.component.svg',
})
export class IconChevronLeftComponent {}
